import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  gap: 4,
}));

export const List = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
  maxWidth: 400,
  maxHeight: 380,
  overflowY: 'auto',
  overflowX: 'hidden',
  '& > *': {
    maxWidth: '100%',
  },
}));
